import {
    IconComponent,
    VvUtvIcon,
    VvAtvIcon,
    VvCruiserIcon,
    VvScooterIcon,
    VvTractorIcon,
    VvTrikeIcon,
    VvDirtBikeIcon,
    VvSportsBikeIcon,
    VvSnowmobileIcon,
    VvEBikeIcon,
    VvGoKartIcon,
    VvGolfCartIcon,
    VvJetskiIcon,
    VvRvMotorhomeIcon,
    VvRvTravelTrailerIcon,
    VvRvToyHaulerIcon,
    VvRvFifthWheelIcon,
    VvSedanIcon,
    VvBoatIcon,
} from '@octane/spark'
import AssetType from 'state/enums/AssetType'

interface IconMap {
    // Powersports
    utv: IconComponent
    atv: IconComponent
    cruiser: IconComponent
    scooter: IconComponent
    trike: IconComponent
    'electric bike': IconComponent
    'go kart': IconComponent
    'golf cart': IconComponent
    tractor: IconComponent
    pwc: IconComponent
    snowmobile: IconComponent
    'dirt bike': IconComponent
    'sports bike': IconComponent
    'sport bike': IconComponent
    // RV
    'class a': IconComponent
    'class a diesel': IconComponent
    'class b': IconComponent
    'class b diesel': IconComponent
    'class c': IconComponent
    'class c diesel': IconComponent
    'camping trailer': IconComponent
    'cargo trailer': IconComponent
    'fifth wheel': IconComponent
    'fold-down': IconComponent
    'pop-up trailer': IconComponent
    teardrop: IconComponent
    'travel trailer': IconComponent
    'truck camper': IconComponent
}

const iconMap: IconMap = {
    // Powersports
    utv: VvUtvIcon,
    atv: VvAtvIcon,
    cruiser: VvCruiserIcon,
    scooter: VvScooterIcon,
    trike: VvTrikeIcon,
    'electric bike': VvEBikeIcon,
    'go kart': VvGoKartIcon,
    'golf cart': VvGolfCartIcon,
    tractor: VvTractorIcon,
    pwc: VvJetskiIcon,
    snowmobile: VvSnowmobileIcon,
    'dirt bike': VvDirtBikeIcon,
    'sports bike': VvSportsBikeIcon,
    'sport bike': VvSportsBikeIcon,
    // RV
    'class a': VvRvMotorhomeIcon,
    'class a diesel': VvRvMotorhomeIcon,
    'class b': VvRvMotorhomeIcon,
    'class b diesel': VvRvMotorhomeIcon,
    'class c': VvRvMotorhomeIcon,
    'class c diesel': VvRvMotorhomeIcon,
    'camping trailer': VvRvTravelTrailerIcon,
    'cargo trailer': VvRvTravelTrailerIcon,
    'fifth wheel': VvRvFifthWheelIcon,
    'fold-down': VvRvTravelTrailerIcon,
    'pop-up trailer': VvRvTravelTrailerIcon,
    teardrop: VvRvTravelTrailerIcon,
    'travel trailer': VvRvTravelTrailerIcon,
    'truck camper': VvRvToyHaulerIcon,
}

export type VehicleType = keyof typeof iconMap

const assetTypeDefaultIconMap: Record<string, IconComponent> = {
    [AssetType.POWERSPORTS_VEHICLE]: VvAtvIcon,
    [AssetType.RECREATIONAL_VEHICLE]: VvRvMotorhomeIcon,
    [AssetType.AUTOMOBILE]: VvSedanIcon,
    [AssetType.MARINE]: VvBoatIcon,
}

const getVehicleTypeIcon = (vehicleType?: string, assetType?: string) =>
    iconMap[vehicleType as VehicleType] ??
    assetTypeDefaultIconMap[assetType as string] ??
    VvAtvIcon

export default getVehicleTypeIcon
